import styled, { css } from 'styled-components';

import { basicBodyTextStyle, Button } from '@dreryk/react-components';

export const StyledVideoConsultationStartButton = styled(Button)`
   ${basicBodyTextStyle}
   border: none;
   padding: 4px 12px;
   ${(props) => css`
      background-color: ${props.theme.success};
      color: ${props.theme.backgroundBody};
      fill: ${props.theme.backgroundBody};
   `}

   &:disabled {
      ${(props) => css`
         background-color: ${props.theme.disabledLight};
         color: ${props.theme.disabledDark};
         fill: ${props.theme.disabledDark};
      `}
   }

   &:not(:disabled):hover {
      ${(props) => css`
         background-color: ${props.theme.successDark};
      `}
   }
`;

StyledVideoConsultationStartButton.displayName = 'StyledVideoConsultationStartButton';
